import axios from '../axios';

export class BaseApi {
  httpClient;

  constructor() {
    this.httpClient = axios;
  }
}
